import {createRouter, createWebHashHistory} from 'vue-router';
import routes from './routes';

const router = createRouter({
  history: createWebHashHistory(), // hash模式：createWebHashHistory，history模式：createWebHistory
  routes,
})
export default router;